import {
  SourceEntityMigrationType,
  type ISourceEntity,
  ISourceEntityTypes,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard, type Timezone } from '@principle-theorem/shared';
import { isNumber, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';
import { STAFF_DESTINATION_ENTITY } from '../../destination/entities/staff';

export const PROVIDER_RESOURCE_TYPE = 'providers';

export const PROVIDER_SOURCE_ENTITY: ISourceEntity = SourceEntity.init({
  metadata: {
    label: 'Provider List',
    description: '',
    idPrefix: PROVIDER_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface IOasisProvider {
  id: number;
  name: string;
  providerNumber?: string;
  initials?: string;
  appointmentBookId?: number;
}

export function isOasisProvider(
  item: unknown,
  logError: boolean
): item is IOasisProvider {
  return TypeGuard.interface<IOasisProvider>(
    {
      id: isNumber,
      name: isString,
      providerNumber: TypeGuard.nilOr(isString),
      initials: TypeGuard.nilOr(isString),
      appointmentBookId: TypeGuard.nilOr(isNumber),
    },
    logError
  )(item);
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IOasisProviderTranslations {}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IOasisProviderFilters {}

const PROVIDER_SOURCE_QUERY = `
SELECT
	convert_to_integer(REGEXP_REPLACE(SKEY, '[A-Za-z]+', '')) AS id,
	F1 AS name,
	F6 AS provider_number,
	F42 AS initials,
  convert_to_integer(F44) AS appointment_book_id
FROM SYUSRDEF
-- The id is parsed out of the key, so skip non-numeric keys such as DOCNAMEXE0000OASIS (the OASiS support login)
WHERE SKEY ~ '^DOCNAMEXE[0-9]+$'
`;

const PROVIDER_SOURCE_QUERY_V2 = `
SELECT
	convert_to_integer(REGEXP_REPLACE(SKEY, '[A-Za-z]+', '')) AS id,
	F1 AS name,
	F6 AS provider_number,
	F10 AS initials
FROM SYTBLENT
-- The id is parsed out of the key, so skip non-numeric keys
WHERE SKEY ~ '^DOCNAMESE[0-9]+$'
`;

export type OasisProvider = ISourceEntityTypes<
  IOasisProvider,
  IOasisProviderTranslations,
  IOasisProviderFilters
>;

export class ProviderSourceEntity extends BaseSourceEntity<OasisProvider> {
  sourceEntity = PROVIDER_SOURCE_ENTITY;
  entityResourceType = PROVIDER_RESOURCE_TYPE;
  sourceQuery = [PROVIDER_SOURCE_QUERY, PROVIDER_SOURCE_QUERY_V2];
  verifySourceFn = isOasisProvider;

  migrationDestinations = [STAFF_DESTINATION_ENTITY.metadata.key];

  translate(
    _data: IOasisProvider,
    _timezone: Timezone
  ): IOasisProviderTranslations {
    return {};
  }

  getSourceRecordId(data: IOasisProvider): number {
    return data.id;
  }

  getSourceLabel(data: IOasisProvider): string {
    return data.name;
  }

  getFilterData(
    _data: IOasisProvider,
    _timezone: Timezone
  ): IOasisProviderFilters {
    return {};
  }
}
